var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRepeatAppt(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8839 11.8254V4.20219C16.8839 3.91391 16.7694 3.63744 16.5655 3.4336C16.3617 3.22975 16.0852 3.11523 15.7969 3.11523H2.75346C2.46518 3.11523 2.18871 3.22975 1.98487 3.4336C1.78102 3.63744 1.6665 3.91391 1.6665 4.20219V15.7964C1.6665 16.0847 1.78102 16.3611 1.98487 16.565C2.18871 16.7688 2.46518 16.8834 2.75346 16.8834H11.8259",
    stroke: "#475467",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.65187 5.28909C5.85197 5.28909 6.01419 5.12687 6.01419 4.92677C6.01419 4.72667 5.85197 4.56445 5.65187 4.56445C5.45177 4.56445 5.28955 4.72667 5.28955 4.92677C5.28955 5.12687 5.45177 5.28909 5.65187 5.28909Z",
    stroke: "#475467",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8985 5.28909C13.0986 5.28909 13.2608 5.12687 13.2608 4.92677C13.2608 4.72667 13.0986 4.56445 12.8985 4.56445C12.6983 4.56445 12.5361 4.72667 12.5361 4.92677C12.5361 5.12687 12.6983 5.28909 12.8985 5.28909Z",
    stroke: "#475467",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.01416 4.92689V1.66602",
    stroke: "#475467",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2607 4.92689V1.66602",
    stroke: "#475467",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1.6665 6.73828H16.8839",
    stroke: "#475467",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7096 18.3323C16.7106 18.3323 18.3328 16.7102 18.3328 14.7091C18.3328 12.7081 16.7106 11.0859 14.7096 11.0859C12.7086 11.0859 11.0864 12.7081 11.0864 14.7091C11.0864 16.7102 12.7086 18.3323 14.7096 18.3323Z",
    stroke: "#475467",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5367 14.7092C12.5333 14.2409 12.6812 13.784 12.9585 13.4065C13.2358 13.029 13.6275 12.7512 14.0755 12.6144C14.5234 12.4775 15.0035 12.489 15.4444 12.6472C15.8853 12.8053 16.2633 13.1015 16.5222 13.4919",
    stroke: "#475467",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8844 14.709C16.8878 15.1773 16.7399 15.6343 16.4626 16.0117C16.1853 16.3892 15.7936 16.667 15.3456 16.8039C14.8977 16.9407 14.4176 16.9292 13.9767 16.7711C13.5358 16.613 13.1578 16.3167 12.8989 15.9264",
    stroke: "#475467",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5366 14.709L13.6236 13.9844",
    stroke: "#475467",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8843 14.709L15.7974 15.4336",
    stroke: "#475467",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRepeatAppt);
export default __webpack_public_path__ + "static/media/repeatAppt.8b4072b2399143e1039d1ab3bbaba7dd.svg";
export { ForwardRef as ReactComponent };